import { useEffect } from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const CONTACT = "Ship@mbstransit.com";

const sections = [
  ["Who we are", "CarrierLaunch is operated by MBS Transit. This policy explains what information we collect when you use CarrierLaunch, why we collect it, and how we protect it."],
  ["What we collect", "Account information: your name and email address when you sign up (directly or through Google). Business information you enter in the setup wizard: legal business name, DBA/trade name, entity type, business phone number, business address, home state, state of operation, interstate or intrastate operation, vehicle types, driver license class and ELD company. Filing progress you record on your dashboard. Questions you ask the AI assistant and its answers. If you buy a plan, payment is handled by Stripe; we receive confirmation of your purchase but never see or store your full card number."],
  ["Why we collect it", "To guide you through USDOT, MC Authority, insurance and other FMCSA filings; to show your progress; to answer your compliance questions; to contact you about your account or filings; and to provide the plan you purchased."],
  ["Who we share it with", "We do not sell your information. We share it only with the service providers that run CarrierLaunch: our hosting provider, our sign-in provider, Stripe for payments, and our AI provider to answer questions you ask the assistant. We may disclose information if required by law."],
  ["How long we keep it", "We keep your information while your account is active. You can ask us to delete your account and data at any time."],
  ["Your choices", "You can view and update your business information in the setup wizard at any time. To request a copy of your data or deletion of your account, email us at the address below."],
  ["Security", "Access to your information is limited to you and the CarrierLaunch owner. Data is sent over encrypted connections."],
  ["Changes", "If we change this policy, we will update the date at the top of this page."],
];

export default function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-[#262626]">
        <div className="max-w-3xl mx-auto px-6 py-4">
          <Link to="/home" className="inline-flex" data-testid="privacy-brand-link">
            <Logo />
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12">
        <div className="font-mono-label text-xs text-[#FFD600] mb-2">LEGAL</div>
        <h1 className="font-heading font-black text-4xl sm:text-5xl leading-none mb-3" data-testid="privacy-title">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground mb-10">Effective October 24, 2026</p>
        <div className="space-y-8">
          {sections.map(([h, body]) => (
            <section key={h}>
              <h2 className="font-heading font-bold text-lg mb-2">{h}</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">{body}</p>
            </section>
          ))}
          <section>
            <h2 className="font-heading font-bold text-lg mb-2">Contact us</h2>
            <p className="text-sm text-muted-foreground">
              Questions about this policy or your data:{" "}
              <a href={`mailto:${CONTACT}`} className="underline text-white" data-testid="privacy-contact-email">{CONTACT}</a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
